import React, { useCallback, useEffect, useState } from "react";

export const useHorizontalScroll = (
  navRef: React.RefObject<HTMLElement>,
  isSticky: boolean = false
) => {
  const [scrollState, setScrollState] = useState({
    isAtStart: true,
    isAtEnd: false
  });

  const updateScrollState = useCallback(
    (element: HTMLElement): void => {
      const isAtStart = element.scrollLeft <= 0;
      const isAtEnd =
        element.scrollLeft >= element.scrollWidth - element.clientWidth - 1;

      setScrollState({ isAtStart, isAtEnd });
    },
    [setScrollState]
  );

  useEffect(() => {
    const element = navRef.current;
    if (!element) return;

    const handleWheel = (e: WheelEvent) => {
      if (Math.abs(e.deltaX) < Math.abs(e.deltaY)) {
        e.preventDefault();

        element.scrollLeft += e.deltaY * 1.5;
      }
    };

    const handleScroll = () => {
      if (!element) return;

      updateScrollState(element);
    };

    element.addEventListener("wheel", handleWheel, { passive: false });
    element.addEventListener("scroll", handleScroll);

    updateScrollState(element);

    return () => {
      element.removeEventListener("wheel", handleWheel);
      element.removeEventListener("scroll", handleScroll);
    };
  }, [navRef]);

  useEffect(() => {
    const element = navRef.current;
    if (!element) return;
    updateScrollState(element);
  }, [isSticky, navRef]);

  return scrollState;
};
